<template>
  <div id="selectTool">
    <div v-show="show" class="selectToolItemWrap">
      <div class="selectToolItem" v-for="(x, index) in forms" :key="index">
        <div class="label">
          <Select
            v-if="x.select"
            v-model="item[x.keys]"
            style="width: 100px"
            :readonly="x.readonlys"
            :disabled="x.disableds"
            :filterable="true"
            :allow-create="x.allowCreates"
          >
            <Option
              :value="x.selectTypes == 'obj' ? y.id : y"
              v-for="(y, index1) in x.selectItemss"
              :key="index1"
              :label="x.selectTypes == 'obj' ? y.name : y"
            >
              <span>{{ x.selectTypes == "obj" ? y.name : y }}</span>
            </Option>
          </Select>
          <p v-else>
            {{ x.title }}
          </p>
        </div>
        <div class="content">
          <ly-input
            v-if="x.type == 'lyInput'"
            v-bind="x.props"
            v-model="item[x.key]"
            style="width:150px"
          ></ly-input>
          <Input
            v-if="x.type == 'Input'"
            v-model="item[x.key]"
            :placeholder="x.placeholder || '请输入'"
            :title="x.placeholder || '请输入'"
            :type="x.type1"
            :rows="x.rows"
            :readonly="x.readonly"
            :disabled="x.disabled"
            :clearable="true"
            :maxlength="x.maxlength"
            :show-word-limit="x.showWordLimit"
            style="width: 150px"
          ></Input>
          <slot v-if="x.slotForm" :name="x.slotForm"></slot>
          <InputNumber
            v-if="x.type == 'InputNumber'"
            v-model="item[x.key]"
            :min="x.min"
            :max="x.max"
            :readonly="x.readonly"
            :disabled="x.disabled"
            :clearable="x.clearable"
            style="width: 140px"
          ></InputNumber>
          <selectGroup
            :name="item[x.key1]"
            @update:name="item[x.key1] = $event"
            :id="item[x.key]"
            @update:id="item[x.key] = $event"
            v-if="x.type == 'selectGroup'"
            @name="item[x.key1] = $event"
            @groupIds="item[x.groupIds] = $event"
            @groupNames="item[x.groupNames] = $event"
            :more="x.more"
          ></selectGroup>
          <RadioGroup v-model="item[x.key]" v-if="x.type == 'radio'">
            <Radio
              :label="x.selectType == 'obj' ? y.id : y"
              v-for="(y, index1) in x.selectItems"
              :key="index1"
              border
              >{{ x.selectType == "obj" ? y.name : y }}</Radio
            >
          </RadioGroup>
          <Select
            v-model="item[x.key]"
            :style="{ width: (x.width ? x.width : 150) + 'px' }"
            v-if="x.type == 'Select'"
            :multiple="x.multiple"
            :readonly="x.readonly"
            :disabled="x.disabled"
            :filterable="true"
            :allow-create="x.allowCreate"
            :max-tag-count="1"
            clearable
            @on-clear="item[x.key] = ''"
            style="width:130px"
          >
            <Option
              :value="x.selectType == 'obj' ? y.id : y"
              v-for="(y, index1) in x.selectItems"
              :key="index1"
              :label="x.selectType == 'obj' ? y.name : y"
            >
              <span>{{ x.selectType == "obj" ? y.name : y }}</span>
            </Option>
          </Select>
          <selectUser
            v-if="x.type == 'selectUser'"
            :name="item[x.key1]"
            @update:name="item[x.key1] = $event"
            :account="item[x.key3]"
            @update:account="item[x.key3] = $event"
            :accountId="item[x.key4]"
            @update:accountId="item[x.key4] = $event"
            :id="item[x.key]"
            @update:id="item[x.key] = $event"
            @accountIds="item[x.accountIds] = $event"
            @accounts="item[x.accounts] = $event"
            @names="item[x.names] = $event"
            :keyword="x.keyword"
            :isHand="x.isHand"
            :clearable="x.clearable"
            :more="x.more"
          >
          </selectUser>

          <selectCar
            v-if="x.type == 'selectCar'"
            :name="item[x.key1]"
            @update:name="item[x.key1] = $event"
            :id="item[x.key]"
            @update:id="item[x.key] = $event"
          >
          </selectCar>

          <selectPerson
            v-if="x.type == 'selectPerson'"
            :name="item[x.key1]"
            @update:name="item[x.key1] = $event"
            :id="item[x.key]"
            @update:id="item[x.key] = $event"
            @deviceIdList="item[x.key] = $event"
            :isMore="x.isMore"
          >
          </selectPerson>
          <selectDriver
            v-if="x.type == 'selectDriver'"
            :name="item[x.key1]"
            @update:name="item[x.key1] = $event"
            :id="item[x.key]"
            @update:id="item[x.key] = $event"
            @driverIdList="item[x.key] = $event"
            :isMore="x.isMore"
          >
          </selectDriver>
          <start-end
            ref="startEnd"
            @StartEndTime="$emit('StartEndTime', $event)"
            v-if="x.type == 'lyyymmdd'"
            :addDay="x.addDay ? 0 : x.addDay"
            :timeModel="x.times"
            :limit="x.limit"
            :datetime="x.formate"
            :clearable="x.clearable"
          ></start-end>
          <selectAlotGroup
            placement="left"
            v-if="x.type == 'selectGroups'"
            @groupIdList="item[x.key] = $event"
            :isMore="x.more"
            noAutoLoad
          ></selectAlotGroup>
          <selecAlotCCar
            v-if="x.type == 'selectAlotCar'"
            @deviceIdList="item[x.key] = $event"
            @carIdList="item[x.carIdList] = $event"
          ></selecAlotCCar>
          <selectAlotDevice
            v-if="x.type == 'selectAlotDevice'"
            @deviceIdList="item[x.key] = $event"
          ></selectAlotDevice>
        </div>
      </div>
      <slot name="item"></slot>
    </div>
    <div class="selectToolItemBottom">
      <slot name="btn"></slot>
      <Button v-if="true" @click="reset" class="chaxun">重置</Button>
      <div style="margin-left: auto;">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>
<script>
import lyInput from "./lyInput.vue";
export default {
  components: { lyInput },
  data() {
    return {
      forms: [],
      item: {},
      keyword: "test",
      show: true,
      defaultItem: {}
    };
  },
  methods: {
    // 获取下拉列表（支持异步/接口）
    getListTest() {
      //let keyword = this.keyword;
      return new Promise(resolve => {
        setTimeout(() => {
          let mydata = [
            { value: 1, label: "haode" },
            { value: 2, label: "haode1" },
            { value: 3, label: "结果" }
          ];
          resolve(mydata);
        }, 500);
      });
    },
    reach(v, item) {
      this.forms = v;
      this.item = item;
      this.defaultItem = JSON.parse(JSON.stringify(item));
      console.log("selectool筛选控件", item);
    },
    getItem() {
      let timeKeyArr = [];
      for (let i = 0; i < this.forms.length; i++) {
        if (this.forms[i].type == "lyyymmdd") {
          if (i == 0 && !this.forms[i].key) {
            //修补旧的没有key1的bug，
            this.forms[i].key1 = "startTime";
          }
          if (i == 0 && !this.forms[i].key1) {
            //修补旧的没有key1的bug，
            this.forms[i].key1 = "endTime";
          }
          let obj = {
            start: this.forms[i].key,
            end: this.forms[i].key1
          };

          timeKeyArr.push(obj);
        }
      }
      for (let i = 0; i < timeKeyArr.length; i++) {
        this.item[timeKeyArr[i].start] = this.$refs.startEnd[
          i
        ].getTimeObj().start;
        this.item[timeKeyArr[i].end] = this.$refs.startEnd[i].getTimeObj().end;
      }
      // if (this.$refs.startEnd) {
      //   this.item.startTime = this.$refs.startEnd[0].getTimeObj().start;
      //   this.item.endTime = this.$refs.startEnd[0].getTimeObj().end;
      //   if (this.$refs.startEnd[1]) {
      //     this.item.auditStartTime = this.$refs.startEnd[1].getTimeObj().start;
      //     this.item.auditEndTime = this.$refs.startEnd[1].getTimeObj().end;
      //   }
      // }

      return this.item;
    },
    showHide() {
      this.show = !this.show;
      this.$emit("show", this.show);
    },
    reset() {
      this.item = { ...this.defaultItem };
      let timeKeyArr = [];
      for (let i = 0; i < this.forms.length; i++) {
        if (this.forms[i].type == "lyyymmdd") {
          timeKeyArr.push(1);
        }
      }
      for (let i = 0; i < timeKeyArr.length; i++) {
        this.$refs.startEnd[i].reset();
      }
    }
  }
};
</script>
<style scoped>
#selectTool {
  padding: 0px 0px 0 0;
}
#selectTool .selectToolItemWrap {
  background: #f5f5f5;
  display: flex;
  flex-wrap: wrap;
  padding: 8px 0px 8px 0;
}
#selectTool .selectToolItemBottom {
  background: #fff;
  padding: 4px 0;
  display: flex;
}
#selectTool #text {
  margin: 8px 0px;
}
#selectTool .selectToolItem {
  display: flex;
  margin-bottom: 6px;
}

#selectTool .content {
}
#selectTool .label {
  margin-left: 10px;
  margin-right: 6px;
  min-width: 60px;
  max-width: 100px;
}
#selectTool .label > p {
  margin-top: 6px;
  font-size: 14px;
  text-align: right;
  height: 20px;
  overflow: hidden;
}
#selectTool button.chaxun {
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/selectTool.vue